
import { PlusOutlined } from '@ant-design/icons-vue';
import { Entity, OioIcon } from '@kunlun/dependencies';
import { isString } from 'lodash-es';
import { computed, defineComponent, PropType, ref } from 'vue';
import { useMetadataProps } from '../../../basic/props';
import FileUpload from '../../common/File.vue';

export default defineComponent({
  name: 'UploadImg',
  components: {
    FileUpload,
    OioIcon,
    PlusOutlined
  },
  inheritAttrs: false,
  props: {
    change: {
      type: Function
    },
    blur: {
      type: Function
    },
    focus: {
      type: Function
    },
    readonly: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: [Boolean, String],
      default: false
    },
    value: {
      type: [Array, Object, String] as PropType<string | (string | object)[]>
    },
    multiple: {
      type: Boolean
    },
    limit: {
      type: [Number, String],
      default: -1
    },
    limitSize: {
      type: [Number, String],
      default: -1
    },
    allLimitSize: {
      type: String,
      default: ''
    },
    uploadPlaceholder: {
      type: String
    },
    uploadIcon: {
      type: String
    },
    uploadIconText: {
      type: String
    },
    limitFileExtensions: {
      type: [String, Array] as PropType<string | string[]>
    },
    remove: {
      type: Function
    },
    translate: {
      type: Function
    }
  },
  emits: ['change', 'remove'],
  setup(props, { emit }) {
    const visible = ref<boolean>(false);
    const previewTitle = ref<string | undefined>('');
    const previewImage = ref<string | undefined>('');
    const { readonly, disabled } = useMetadataProps(props, true);

    const handlePreview = async (flage, file) => {
      if (typeof file !== 'boolean') {
        previewTitle.value = file.name || file.url || file.preview;
        previewImage.value = file.url || file.preview;
      }
      visible.value = flage;
    };

    const fileList = computed(() => {
      const value = props.value;
      let currentValues: (string | object)[] | undefined;
      if (Array.isArray(value)) {
        currentValues = value;
      } else if (value != null) {
        currentValues = [value];
      }
      return (currentValues || []).map((a) => {
        if (isString(a)) {
          // image/* 是为了修复 antdv 无法识别url后缀不是图片后缀的情况，问题url: https://tse2-mm.cn.bing.net/th/id/OIP-C.U9y6BAOlqCDh4ufC_2kIgwHaFj?w=280&h=209&c=7&r=0&o=5&dpr=2&pid=1.7
          return { url: a, type: 'image/*' };
        }
        return { ...(a as unknown as Entity), type: 'image/*' };
      });
    });

    const onChangeFile = (v) => {
      props.change && props.change(v);
      emit('change', v);
    };

    const onRemoveFile = (v) => {
      props.remove && props.remove(v);
      emit('remove', v);
    };

    return {
      visible,
      previewTitle,
      previewImage,
      readonly,
      disabled,
      fileList,
      handlePreview,
      onChangeFile,
      onRemoveFile
    };
  }
});
